// extracted by mini-css-extract-plugin
export default {"container":"iK-z","topReviewHeading":"jK-z","criticalReview":"kK-z","favorableReview":"lK-z","vsSeparator":"mK-z"};